import { getBaseURL } from '@/utils/util'
const baseURL = getBaseURL('api')
const otabaseURL = getBaseURL('ota')

export const modifyLoginAccount = data => window.axios({
  url: baseURL + 'companyOperator/changePassWord',
  data,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const accountLogout = () => window.axios({
  method: 'get',
  url: baseURL + 'companyOperator/logout?type=WEB'
})

export const getAccountAuth = () => window.axios({
  url: baseURL + 'companyOperator/operatorCountryTypeTool'
})

export const getFliggyFinancialAuth = () => window.axios({
  url: otabaseURL + 'feizhu/new/config'
})
